import React from 'react'

export default function LoadingPage() {
  return (
    <div className='loadingpage'>
        <div class="spinner"></div>
    </div>
  )
}
